import HelpText from "../helpText/HelpText";
import styles from "./selectionInputs.module.scss";
import { forwardRef } from "react";

/**
 * 아직 정리 안됨 .. 정리하고 나면 주석 제거할 예정
 * 사용에 참고 바랍니다
 */
// interface Props
interface Props {
  type?: "checkbox" | "radio";
  children: React.ReactNode;
  direction?: "vertical" | "horizontal";
  helpTextComponent?: React.ReactNode;
  resultObj?: { [key: string]: string };
  showHelpTextError?: boolean;
  showHelpTextSuccess?: boolean;
  style?: React.CSSProperties;
}

export const SelectionInputsWrap = forwardRef<HTMLTextAreaElement, Props>((props, ref) => {
  const { type = "checkbox", children, direction = "horizontal", helpTextComponent, style } = props;
  return (
    <>
      <div className={`${styles[`input-${type}-list`]} ${styles[direction]}}`} style={style || {}}>
        {children}
      </div>
      {helpTextComponent && (
        <div className={styles[`input-${type}-help-text`]}>{helpTextComponent}</div>
      )}
    </>
  );
});

export const SelectionInputWrap = ({
  children,
  type = "checkbox",
  style,
  labelPosition = "after",
  desc,
}: {
  children: React.ReactNode;
  type?: "radio" | "checkbox";
  style?: React.CSSProperties;
  labelPosition?: "before" | "after";
  desc?: React.ReactNode;
}) => {
  return (
    <>
      <div className={`${styles[`input-${type}-item-wrap`]}`} style={style || {}}>
        <div
          className={`${styles[`input-${type}-item`]} ${labelPosition === "before" ? styles["input-label-first"] : ""}`}
        >
          {children}
        </div>
        {desc && <HelpText helpTextComponent={<>{desc}</>} />}
      </div>
    </>
  );
};
